import { FaPlay } from "react-icons/fa6";
import { Link, useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { getTestList } from "../../api/mainApi";

function TestItems({ limit = null, showMore = false }) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [tests, setTests] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchTests = async () => {
      try {
        const data = await getTestList(limit);
        setTests(data || []);
      } catch (error) {
        console.error("Error fetching test list:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchTests();
  }, [limit]);

  const handleStartTest = (testId) => {
    navigate(`/test/${testId}`);
  };

  const SkeletonCard = () => (
    <div className="rounded-2xl p-5 bg-black/40 backdrop-blur-md border border-white/5 animate-pulse">
      <div className="flex flex-col gap-y-3">
        <div className="h-6 bg-slate-700/50 rounded w-full"></div>
        <div className="h-4 bg-slate-700/30 rounded w-3/4"></div>
        <div className="h-4 bg-slate-700/30 rounded w-1/2"></div>
        <div className="flex justify-between gap-y-2 mt-3">
          <div className="h-6 bg-slate-700/50 rounded-full w-20"></div>
          <div className="h-6 bg-slate-700/50 rounded-full w-24"></div>
        </div>
      </div>
    </div>
  );

  return (
    <div className="flex flex-col gap-y-4">
      {loading ? (
        <>
          {Array.from({ length: limit || 3 }, (_, i) => (
            <SkeletonCard key={i} />
          ))}
        </>
      ) : tests.length > 0 ? (
        <>
          {tests.map((test) => (
            <button
              className="rounded-2xl p-5 bg-black/40 backdrop-blur-md border border-white/5 shadow-lg hover:bg-black/60 hover:border-white/10 hover:-translate-y-1 transition-all duration-300 text-left w-full group"
              onClick={() => handleStartTest(test?.id)}
              key={test?.id}
            >
              <div className="flex flex-col gap-y-2">
                <div>
                  <p className="font-bold text-white line-clamp-2">
                    {test?.name} <span className="text-cyan-400 font-medium">({test?.shortName})</span>
                  </p>
                  <p className="text-sm text-gray-400 mt-2 line-clamp-5">
                    {test?.description}
                  </p>
                  <div className="flex justify-between items-center gap-y-2 mt-4">
                    {/* Dark Pills */}
                    <div className="px-3 py-1 rounded-full bg-black/50 border border-white/5 text-xs font-medium text-emerald-400 line-clamp-1 truncate">
                      {test?.category}
                    </div>
                    <div className="px-3 py-1 rounded-full bg-black/50 border border-white/5 text-xs font-medium text-cyan-400 truncate">
                      {test?.itemsCount} {t("tests.questions")}
                    </div>
                  </div>
                </div>
              </div>
            </button>
          ))}
          {showMore && (
            <Link
              to="/tests"
              className="w-full py-3 mt-2 text-center font-medium rounded-xl bg-black/40 backdrop-blur-md border border-white/5 text-gray-300 hover:text-white hover:bg-black/60 transition-all duration-300"
            >
              {t("showFull")}
            </Link>
          )}
        </>
      ) : (
        <p className="text-gray-500 text-lg text-center bg-black/20 py-4 rounded-xl border border-white/5">
          {t("tests.empty")}
        </p>
      )}
    </div>
  );
}

export default TestItems;